export var SELECT_ELEMENTS = {
    SELECT: 'select-select',
    VALUE: 'select-value',
    OPTION: 'select-option',
    OPTIONS: 'select-options',
};
var PREFIX = 'events';
export var EVENT_TITLE = 'EVENT_TITLE';
export var eventDetails = 'event-details';
export var eventDetailsContent = 'content-container';
export var eventDetailsFullLocation = 'event-full-location';
export var subtitleTimeAndLocation = 'time-and-location';
export var header = 'header';
export var headerEventTitle = 'event-title';
export var headerEventDescription = 'event-description';
export var headerShortDateLocation = 'short-date-location';
export var headerShortDate = 'event-short-date';
export var headerShortLocation = 'event-short-location';
export var HEADER_GET_TICKETS_BUTTON = 'get-tickets-button';
export var ABOUT_SECTION = 'about-section';
export var ABOUT_SECTION_TEXT = 'about-section-text';
export var ABOUT_SECTION_BUTTON = 'about-section-button';
export var ABOUT_SECTION_WRAPPER = 'about-section-wrapper';
export var MAP = 'map';
export var eventImage = 'event-image';
export var CHECKOUT_STEP = function (key) { return PREFIX + ".CHECKOUT_STEP-" + key; };
export var CHECKOUT_STEP_TITLE = PREFIX + ".CHECKOUT_STEP_TITLE";
export var CHECKOUT_STEP_EDIT = PREFIX + ".CHECKOUT_STEP_EDIT";
export var CHECKOUT_BUYER_DETAILS = PREFIX + ".CHECKOUT_BUYER_DETAILS";
export var CHECKOUT_SUMMARY_SUBTOTAL = PREFIX + ".CHECKOUT_SUMMARY_SUBTOTAL";
export var CHECKOUT_SUMMARY_DISCOUNT = PREFIX + ".CHECKOUT_SUMMARY_DISCOUNT";
export var CHECKOUT_SUMMARY_TOTAL = PREFIX + ".CHECKOUT_SUMMARY_TOTAL";
export var SHOW_SUMMARY_BUTTON = 'SHOW_SUMMARY_BUTTON';
export var EVENT_DETAILS_MEMBERS = PREFIX + ".MEMBERS";
export var MEMBERS_TITLE = "members-title";
export var UPDATE_MEMBER_EVENT = PREFIX + ".UPDATE_MEMBER_EVENT";
export var RSVP_INFO_BUTTON = 'RSVP_INFO_BUTTON';
export var TICKET = 'ticket';
export var RESERVATION_TIMER = 'reservation-timer';
export var COUPON_CODE_EXPAND_BUTTON = 'coupon-code-expand-button';
export var COUPON_FORM = 'coupon-form';
export var COUPON_CODE_INPUT = 'coupon-code-input';
export var COUPON_CODE_CLEAR = 'coupon-code-clear';
export var COUPON_CODE_SUBMIT = 'coupon-code-submit';
export var COUPON_ERROR = 'coupon-error';
export var COUPON_INPUT_INFO = 'coupon-input-info';
export var COUPON_CHECKING_VALIDITY = 'coupon-checking-validity';
export var TICKET_DETAILS_FORM = function (index) { return "ticket-details-form-" + index; };
export var DESKTOP = 'desktop';
export var MOBILE = 'mobile';
export var ORDER_SUCCESS = 'order-success';
export var ORDER_SUCCESS_TITLE = 'order-success-title';
export var ORDER_SUCCESS_SUBTITLE = 'order-success-subtitle';
export var INVOICE_TITLES = 'invoice-titles';
export var INVOICE_BREAKDOWN = 'invoice-breakdown';
export var DISCOUNT_PRICE = 'discount-price';
export var PAID_PLAN_DISCOUNT_PRICE = 'paid-plan-discount-price';
export var TAX = 'tax';
export var TAX_LABEL = 'tax-label';
export var WIX_FEE = 'wix-fee';
export var ORDER_SUCCESS_SUMMARY = 'order-success-summary';
export var ORDER_SUCCESS_SUMMARY_WRAPPER = 'order-success-summary-wrapper';
export var SUBTOTAL = 'subtotal';
export var TOTAL_PRICE = 'total-price';
export var BACK_TO_SITE = 'back-to-site';
export var PRINT = 'print';
export var DOWNLOAD = 'download';
export var ORDER_NUMBER = 'order-number';
export var PLACED_ON = 'placed-on';
export var QUANTITY_PICKER = 'quantity-picker';
export var MINUS_BUTTON = 'minus-button';
export var PLUS_BUTTON = 'plus-button';
export var QUANTITY_VALUE = 'quantity-value';
export var RSVP_BUTTON = 'rsvp-button';
export var RSVP_OPENS_LABEL = 'rsvp-opens-label';
export var RSVP_CLOSES_LABEL = 'rsvp-closes-label';
export var CHECKOUT = 'checkout';
export var CHECKOUT_BUTTON = 'checkout-button';
export var CLOSE_BUTTON = 'close-btn';
export var RESERVE_TICKETS_BUTTON = 'reserve-tickets-button';
export var FORM_BUTTON = 'form-button';
export var FORM_INVALID_FIELD = 'form-invalid-field';
export var FORM_ADDRESS_LABEL = 'address-caption';
export var FORM_ADDRESS_INPUT = 'address-input';
export var FORM_ADDRESS_ERROR = 'address-error';
export var FORM_DATE_LABEL = 'date-caption';
export var FORM_DATE_INPUT_MONTH = 'date-input-month';
export var FORM_DATE_INPUT_DAY = 'date-input-day';
export var FORM_DATE_INPUT_YEAR = 'date-input-year';
export var FORM_DATE_ERROR = 'date-error';
export var PAYMENT_METHOD_SUBMIT = 'payment-method-submit';
export var TICKET_NAME = 'ticket-name';
export var TICKET_PRICE = 'ticket-price';
export var TICKET_QUANTITY = 'ticket-quantity';
export var TICKET_TOTAL_PRICE = 'ticket-total-price';
export var TICKETS_PICKER = 'tickets-picker';
export var TICKETS_PICKER_TITLES = 'tickets-picker-titles';
export var TICKETS_PICKER_HEADER_TITLE = 'header-title';
export var TICKETS_PICKER_HEADER_PRICE = 'header-price';
export var TICKETS_PICKER_HEADER_QUANTITY = 'header-qty';
export var TICKETS_PICKER_HEADER_TOTAL = 'header-total';
export var TICKETS_PICKER_FOOTER = 'tickets-picker-footer';
export var TICKETS_SUMMARY = 'tickets-summary';
export var TICKET_WRAPPER = 'ticket-wrapper';
export var TICKET_SOLD_OUT = 'ticket-sold-out';
export var TICKET_GOES_ON_SALE = 'ticket-goes-on-sale';
export var TICKET_SALE_ENDS = 'ticket-sale-ends';
export var TICKET_SALE_ENDED = 'ticket-sale-ended';
export var MEMBERSHIP_OFFERS = 'membership-offers';
export var MEMBERSHIP_OFFERS_PROMO = 'membership-offers-promo';
export var MEMBERSHIP_OFFERS_DETAILS = 'membership-offers-details';
export var MEMBERSHIP_OFFERS_PLAN = 'membership-offers-plan';
export var MEMBERSHIP_OFFERS_PLAN_NAME = 'membership-offers-plan-name';
export var MEMBERSHIP_OFFERS_PLAN_BENEFIT = 'membership-offers-plan-benefit';
export var MEMBERSHIP_OFFERS_PLAN_PRICING = 'membership-offers-plan-pricing';
export var MEMBERSHIP_OFFERS_PLAN_INFO = 'membership-offers-plan-info';
export var MEMBERSHIP_OFFERS_BUY = 'membership-offers-buy';
export var MEMBERSHIP_OFFERS_LOGIN = 'membership-offers-login';
export var MEMBERSHIP_SELECTOR = 'membership-selector';
export var SHOW_DETAILS_TOGGLE = 'show-details-toggle';
export var SHOW_DETAILS_TOGGLE_HIDE = 'show-details-toggle-hide';
export var SHOW_DETAILS_TOGGLE_SHOW = 'show-details-toggle-show';
export var MEMBERSHIP_SELECTOR_OPTION_TITLE = 'membership-selector-option-title';
export var MEMBERSHIP_SELECTOR_OPTION_SUBTITLE = 'membership-selector-option-subtitle';
export var FIRST_NAME_INPUT = 'first-name-input';
export var THANK_YOU_MESSAGE = 'thank-you-message';
export var THANK_YOU_MESSAGE_TITLE = 'thank-you-message-title';
export var THANK_YOU_MESSAGE_NOTIFICATION = 'thank-you-message-notification';
export var ADD_TO_CALENDAR = 'add-to-calendar';
export var DOWNLOAD_TICKETS = 'download-tickets';
export var DOWNLOAD_PDF = 'download-pdf';
export var DOWNLOAD_APPLE_WALLET = 'download-apple-wallet';
export var SOCIAL_SHARE_TITLE = 'social-share-title';
export var SOCIAL_SHARE = 'social-share';
export var SOCIAL_SHARE_ICON_FACEBOOK = 'social-share-icon-facebook';
export var SOCIAL_SHARE_ICON_TWITTER = 'social-share-icon-twitter';
export var SOCIAL_SHARE_ICON_LINKEDIN = 'social-share-icon-linkedin';
export var NAME = 'name';
export var DESCRIPTION = 'description';
export var MORE_BUTTON = 'more-button';
export var TOTAL = 'total';
export var PRICE = 'price';
export var SOLD_OUT_LABEL = 'sold-out-label';
export var DISCOUNT_NAME = 'discount-name';
export var AVATAR = 'avatar';
export var POLICY = 'policy';
export var CHECKBOX = 'checkbox';
export var CHECKBOX_INPUT = 'checkbox-input';
export var CHECKBOX_LABEL = 'checkbox-label';
export var NO_RADIO_BUTTON = 'no-radio-button';
export var YES_RADIO_BUTTON = 'yes-radio-button';
export var CLOSED_REGISTRATION = 'closed-registration';
export var EVENT_FULL_DATE = 'event-full-date';
export var TICKETS_UNAVAILABLE = 'tickets-unavailable';
export var SCHEDULE = 'schedule';
export var SCHEDULE_SUBTITLE = 'schedule-subtitle';
export var SCHEDULE_SEE_ALL = 'schedule-see-all';
export var NO_SCHEDULE_EMPTY_STATE = 'no-schedule-empty-state';
export var RECURRING_DATES_BUTTON = 'recurring-dates-button';
export var GROUPS_JOIN_BUTTON = 'groups-join-button';
export var GROUPS_ACTIVITY = 'groups-activity-indication';
export var SEATINGS_MODAL = 'seatings-modal';
export var EVENT_INFO = 'event-info';
export var ADD = 'add';
export var TICKETS_DOWNLOAD_MODAL = 'tickets-download-modal';
export var ORDER_SUMMARY_MODAL = 'order-summary-modal';
export var ACCESSIBILITY_MODE_BUTTON = 'accessibility-mode-button';
export var BACK = 'back';
export var ADD_TICKETS_TO_CART_BUTTON = 'ADD_TICKETS_TO_CART_BUTTON';
export var ACCESSIBILITY_MODE_END = 'ACCESSIBILITY_MODE_END';
export var REMOVE_TICKET = 'REMOVE_TICKET';
export var REVIEW_AND_CHECKOUT = 'REVIEW_AND_CHECKOUT';
export var VIEW_BASKET = 'VIEW_BASKET';
export var SEATING_PRICE_FILTER = 'SEATING_PRICE_FILTER';
export var SEATING_ZONE_FILTER = 'SEATING_ZONE_FILTER';
export var OPTION = 'option';
export var COUNTER_PLUS_BUTTON = 'counter-plus-button';
//# sourceMappingURL=details-page.js.map